// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
import { showSuccess, showError } from "../actions/globalActions";

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => ({
  headers: {
    'Authorization': `Bearer ${token}`,
  },
});

const useEmailTemplateStore = create(immer((set) => ({
  templates: [],

  getTemplatesByOrganization: (getToken) => async (organizationId) => {
    try {
      const token = await getToken();
      const { data } = await axios.get(
        `${baseUrl}/emailTemplates/d/organization/${organizationId}`,
        createAuthHeader(token),
      );
      set((state) => {
        state.templates = data.result || [];
      });
    } catch (error) {
      console.error("Error in getTemplatesByOrganization:", error);
    }
  },

  getTemplateByKey: (getToken) => async (organizationId, templateKey) => {
    try {
      const token = await getToken();
      const { data } = await axios.get(
        `${baseUrl}/emailTemplates/d/organization/${organizationId}/${templateKey}`,
        createAuthHeader(token),
      );
      const result = data.result;
      set((state) => {
        if (!result) return;
        const index = state.templates.findIndex(
          (t) => t.organization === organizationId && t.templateKey === templateKey,
        );
        if (index >= 0) state.templates[index] = result;
        else state.templates.push(result);
      });
      return result;
    } catch (error) {
      console.error("Error in getTemplateByKey:", error);
    }
  },

  upsertTemplate: (getToken) => async (organizationId, templateKey, payload) => {
    try {
      const token = await getToken();
      const { data } = await axios.put(
        `${baseUrl}/emailTemplates/d/organization/${organizationId}/${templateKey}`,
        payload,
        createAuthHeader(token),
      );
      const result = data.result;
      set((state) => {
        const index = state.templates.findIndex(
          (t) => t.organization === organizationId && t.templateKey === templateKey,
        );
        if (index >= 0) state.templates[index] = result;
        else state.templates.push(result);
      });
      showSuccess("Success", "Template saved");
      return result;
    } catch (error) {
      showError("Error", "Save Error");
      console.error("Error in upsertTemplate:", error);
    }
  },
})));

export default useEmailTemplateStore;
